import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-reports-list',
  templateUrl: './reports-list.component.html',
  styleUrls: ['./reports-list.component.scss'],
})
export class ReportsListComponent extends BaseListCtl {
  public show: boolean = false;
  public usecases: any[] = [];
  public forms: any[] = [];
  public reportIdFromUrl: any = null;
  public searchdata: any;
  public titlereport: any;
  public uiFormId: any;
  public searchList: any;
  public uiFormData: any; 
  public autoUpdateReport: any;
  public reportId: any;
  componentFlag: boolean = true;


  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(locator.config.get('endpoint.reports'), locator, route);
    let _self = this;
    this.applicationId = this.route.snapshot.paramMap.get('id');
    this.reportIdFromUrl = this.route.snapshot.paramMap.get('reportid');
  }
  public applicationId: any;
  /**
   * Toggle the value of Search button
   */
  showSearch() {
    let _self = this;
    _self.show = !_self.show;
  }

  override ngOnInit(): void {
    this.getUsecases();
    this.preload();
    this.resetSearchForm();
    if (this.reportIdFromUrl) {
      this.loadReportById(this.reportIdFromUrl);
    }
  }

  loadReportById(reportId: any) {
    this.locator.config.getProperty('endpoint.reports').then((property: string) => {
      this.locator.http.get(property + '/get/' + reportId, (res: any, error: any) => {
        if (error || !res.success) return;
        this.setDetails(res.result.data); 
      });
    });
  }
 
  setDetails(value: any) {
    let _self = this;
    _self.searchdata = value['dataJson'];
    _self.uiFormData = value['dataJson']['data'];
    _self.titlereport = value['title'];
    _self.uiFormId = value['uiFormId'];
    _self.reportId = value['id'];
    _self.searchList = value?.searchList;
    _self.autoUpdateReport = value['autoUpdateReport'];
    this.componentFlag = false;
    setTimeout(() => {
      this.componentFlag = true;
    }, 0);
  }

  /**
   * Delete a record and execute callback after deletion
   *
   * @param id
   * @param callback
   */
  override delete(id: any, callback?: any) {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    if (id && id > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }
      }
      this.locator.config
        .getProperty('endpoint.reports')
        .then((property: any) => {
          this.locator.http.get(
            property + '/delete/' + id,
            function (res: any, error: any) {
              if (error) {
                return;
              }
              _self.form.error = !res.success;
              _self.form.message = res.result.message;
              if (res.success) {
                _self.form.message = 'Data is deleted';
                _self.search();
                if (callback) {
                  callback(res, error);
                }
              }
            }
          );
        });
    }
  }

  /**
   * Get usecases list
   */
  public async getUsecases() {
    let url =
      this.locator.getEndpoint('endpoint.application.role.usecase') +
      '/usecases/' +
      this.applicationId;

    this.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      this.usecases = res.result.data;
    });
  }

  /**
   * Get Forms by usecaseId
   */
  public getForms(appId: any) {
    console.log('appId in get forms method', appId);
    // Reset previous selections
    this.form.data['formId'] = undefined;
    this.form.searchParams['uiFormId'] = undefined;

    const selectedUsecase = this.usecases.find(
      (e: any) => e.id === Number(appId)
    );
    if (selectedUsecase) {
      this.form.data['apiName'] = selectedUsecase.name;
    }

    const url = this.locator.getEndpoint('endpoint.reports') + '/searchform';

    // Build payload
    const payload = { appId: Number(appId) };

    this.locator.http.post(url, payload, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      this.forms = res.result.data;
    });
  }

  /**
   * override the default search function for list null on false response
   * @param callback
   */
  override search(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    if (this.applicationId) {
      _self.form.searchParams['applicationId'] = Number(this.applicationId);
    }

    if (_self.form.searchParams['applicationName']) {
      _self.form.searchParams['applicationId'] = Number(
        _self.form.searchParams['applicationName']
      );
    }

    this.locator.config
      .getProperty(_self.api.endpoint)
      .then((property: string) => {
        let url = _self.api.search + '/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        // ✅ Build payload correctly
        let payload: any = { ..._self.form.searchParams };

        // ✅ Ensure numeric types
        if (payload['applicationId']) {
          payload['applicationId'] = Number(payload['applicationId']);
          this.getForms(Number(this.applicationId));
        }
        if (payload['uiFormId']) {
          payload['uiFormId'] = Number(payload['uiFormId']);
        }

        // ✅ Rename if needed
        // if (payload['applicationId'] && !_self.form.searchParams['uiFormId']) {
        //   payload['uiFormId'] = payload['applicationId'];
        //   delete payload['applicationId'];
        // }

        console.log('Final payload being sent to backend:', payload);

        this.locator.http.post(url, payload, function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }
              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.list = res.result.data;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];

              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              if (_self.form.list.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

            if (callback) callback();
            } else {
              _self.form.list = [];
            }
          if (callback) callback();
        });
      });
  }

  transform(value: string, limit: number = 15): string {
    if (!value) return '';
    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }

  onApplicationChange(event: MatSelectChange) {
    // In Angular Material, the value is directly on the event object
    const appId = event.value;

    console.log('Selected appId:', appId);

    // Reset form selection
    this.form.searchParams['uiFormId'] = undefined;

    // Fetch forms for this app
    if (appId !== undefined) {
    this.getForms(Number(appId));
   }
  }


  toggleDashboard(report: any) {
  let _self = this;
  const newValue = report.addOnDashboardReport == 1 ? 0 : 1;

  _self.locator.config.getProperty('endpoint.reports').then((property: string) => {
    let url = property + '/save';
    let payload = {
      ...report,
      addOnDashboardReport: newValue
    };

    _self.locator.http.post(url, payload, function (res: any, error: any) {
      if (error || !res.success) return;      
      report.addOnDashboardReport = newValue;
    });
  });
}
}
